<div class="form-group">
    <div class="row">
        <div class="col">
            <label class="input-label">{{ 'Groups' | translate }}</label>
            <div class="table-items">
                <div
                    cdkDropList
                    [cdkDropListData]="groups"
                    (cdkDropListDropped)="dropped($event)">
                    <div cdkDrag class="item" *ngFor="let group of groups; let first = first; let last = last; let i = index">
                        <div class="row">
                            <div class="col-auto align-items-center justify-content-start">
                                <i cdkDragHandle class="fa-solid fa-grip-dots handle ml-1"></i>
                            </div>
                            <div class="col-auto align-items-center justify-content-start pl-0" (click)="group.defaultStatus = !group.defaultStatus; saveDefaultStatus(group);" tooltip="{{'Opened or closed by default' | translate}}">
                                <i class="fa-toggle-large-on {{group.defaultStatus ? '' : 'fa-flip-horizontal toggle__icon'}} fas toggle-primary"></i>
                            </div>
                            <div class="col cursor-row px-0 align-items-center justify-content-start" (click)="editGroup(group);">
                                {{ group.name | translate }}
                                <span class="badge badge-light ml-2" style="margin-top: 3px" tooltip="{{'Number of services' | translate}}">{{ group.services?.length }}</span>
                            </div>
                            <div class="col-auto cursor-row align-items-center justify-content-end">
                                <i class="fal fa-pencil mr-2" (click)="editGroup(group);"></i>
                                <!--<i class="fas fa-times btn-xs btn-bordered btn-danger btn-icon item-remove"
                                (click)="removeGroup(group); $event.stopPropagation()"></i>-->
                                <confirmation-popover
                                    className="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action"
                                    (onConfirmed)="removeGroup(group)"></confirmation-popover>
                            </div>
                        </div>
                    </div>
                    <div class="item" *ngIf="systemProperties && systemProperties.bpaProperties">
                        <div class="row">
                            <div class="col-auto align-items-center justify-content-start">
                                <i class="fa-solid fa-grip-dots handle ml-1 invisible"></i>
                            </div>
                            <div class="col-auto align-items-center justify-content-start pl-0" tooltip="{{'Opened or closed by default' | translate}}" (click)="systemProperties.bpaProperties.defaultGroupDefault = !this.systemProperties.bpaProperties.defaultGroupDefault; editSystemProperties();">
                                <i class="fa-toggle-large-on {{systemProperties.bpaProperties.defaultGroupDefault ? '' : 'fa-flip-horizontal toggle__icon'}} fas toggle-primary"></i>
                            </div>
                            <div class="col cursor-row px-0 align-items-center justify-content-start">
                                {{ "Ungrouped services" | translate }}
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="row">
                            <div class="col-10 align-items-center justify-content-start">
                                <input class="form-control" type="text" [(ngModel)]="tempName" #name="ngModel"
                                placeholder="{{ 'Add group' | translate }}">
                            </div>
                            <div class="col-2 align-items-center justify-content-end">
                                <button class="editBtn btn-dark" (click)="editGroup(tempGroup);$event.stopPropagation()">{{ 'Add' | translate }}</button>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
  </div>

  <drawer [title]="'Edit group'" [isClosed]="isDrawerClosed" (saveEvent)="saveGroup($event);" (closeEvent)="closeDrawer();" class="text-left">
    <group-manage [group]="tempGroup"></group-manage>
  </drawer>